import React from 'react';
import reactStringReplace from '../../misc/reactStringReplace';
import nl2br from 'react-br';
import emailRegexp from '../../misc/regexp-email';
import urlRegexp from '../../misc/regexp-url';

export default class HighlightSpecialContents extends React.Component {
    render() {
        let TagName = this.props.tagName || 'div',
            classes = ['parse-tags ', this.props.className],
            k = 0,
            children = _.chain(React.Children.toArray(this.props.children))
                .map(child => {
                    if (!_.isString(child)) {
                        let props = Object.assign({}, this.props, {tagName: child.type, className: child.props.className});
                        delete props.children;
                        return (
                            <HighlightSpecialContents tagName={child.type} {...props}>
                                {child.props.children}
                            </HighlightSpecialContents>
                        );
                    }
                    return child;
                })
                .map(child => {
                    if (_.isString(child) && this.props.emails) {
                        return reactStringReplace(child, emailRegexp, address => {
                            return (
                                <a href={'mailto:' + address} target="_blank" rel="noopener noreferrer" key={'k' + k++}>
                                    {address}
                                </a>
                            );
                        });
                    }
                    return child;
                })
                .flatten()
                .map(child => {
                    if (_.isString(child) && this.props.urls) {
                        return reactStringReplace(child, urlRegexp, address => {
                            let prefix = '';
                            if (!address.match(/\:\/\//)) {
                                prefix = '//';
                            }
                            return (
                                <a href={prefix + address} target="_blank" rel="noopener noreferrer">
                                    {address}
                                </a>
                            );
                        });
                    }
                    return child;
                })
                .flatten()
                .map(child => {
                    if (_.isString(child)) {
                        return nl2br(child);
                    }
                    return child;
                })
                .flatten()
                .map((c, i) => <span key={i}>{c}</span>)
                .value();

        return <TagName className={classes.join(' ')}>{children}</TagName>;
    }
}
